import * as Yup from 'yup';

export const LoginShema = (t) =>
	Yup.object().shape({
		email: Yup.string().email().required(t('common:required')),
		password: Yup.string().required(t('common:required'))
	});
